import { IStaticClassName, IInitializableWithStaticClassName, IInitializable } from "./Initializable";
import { Initializer } from "./Initializer";

export class Page<T extends IStaticClassName, DatasetKeys extends string = any> implements IInitializableWithStaticClassName<T> {
    /**
     * Typed dataset of the root element
     */
    protected readonly dataset: {
        [K in DatasetKeys]: string | undefined;
    };

    constructor(
        protected readonly rootElement: HTMLElement,
        protected readonly index: number
    ) {
        this.dataset = (rootElement.dataset as {
            [K in DatasetKeys]: string | undefined;
        });
    }

    getRootElement(): HTMLElement {
        return this.rootElement;
    }

    /**
     * 
     * Get component of the page
     * 
     * @param selector - selector of the component to get
     * @returns - component of the page or null if not found
     */
    protected getComponent<T extends IInitializable>(selector: string): T | null {
        const element = this.rootElement.querySelector<HTMLSelectElement>(selector);

        if (!element) {
            return null;
        }

        return Initializer.getComponent<T>(element);
    }

    destroy() {};
}